import { render, staticRenderFns } from "./CampaignTab.ts.vue?vue&type=template&id=17b4afe1"
import script from "./CampaignTab.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignTab.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports